var React = require('react');

function IconPlayCircleSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M512 65.2C264.7 65.2 64.3 265.7 64.3 513s200.5 447.8 447.8 447.8S959.9 760.3 959.9 513 759.3 65.2 512 65.2zm172 468.7L447.9 686c-12.9 8.4-30.1 4.4-30.1-20.3V366.1c0-27 16.1-27.8 30.1-20.3L684 498c9.7 9.9 9.7 26 0 35.9z"}));
}

IconPlayCircleSolid.displayName = "IconPlayCircleSolid";

IconPlayCircleSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconPlayCircleSolid;

IconPlayCircleSolid.default = IconPlayCircleSolid;
